var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"logo",attrs:{"to":"/"}},[_c('svg',[_c('use',_vm._b({attrs:{"href":_vm.getSvgUrl('#logo')}},'use',{'xlink:href': _vm.getSvgUrl('#logo')},false))])]),_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view',{attrs:{"appData":_vm.appData,"posts":_vm.posts,"homePosts":_vm.homePosts}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }